import React from 'react';

export const BugSVG = props => {
	const { id } = props;

	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='64' height='64'
viewBox='0 0 64 64'
		>
			<defs>
				<linearGradient
					id='swipe-gradient-bug'
					x1='0.5'
					y1='1'
					x2='0.5'
					y2='-2'
					gradientTransform='rotate(35)'
				>
					<stop offset='0' stop-color='#f58145'>
						<animate
							id={`trans4-${id}`}
							dur='1s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
					<stop offset='0' stop-color='#7b868c'>
						<animate
							id={`trans4-${id}`}
							dur='1s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
				</linearGradient>
				<linearGradient
					id='h9budw8vub'
					x1='.875'
					x2='.004'
					y1='.788'
					y2='.107'
					gradientUnits='objectBoundingBox'
				>
					<stop offset='0' stop-color='#c1c5c8' />
					<stop offset='1' />
				</linearGradient>
				<linearGradient
					id='61tjovevqc'
					x1='1.327'
					x2='.332'
					y1='1.138'
					y2='.328'
					gradientUnits='objectBoundingBox'
				>
					<stop offset='0' stop-color='#edefef' />
					<stop offset='.475' stop-color='#fff' />
					<stop offset='1' stop-color='#d4d7d8' />
				</linearGradient>
				<clipPath id='604xhcotta'>
					<circle cx='32' cy='32' r='32'
fill='#7b868c' transform='translate(149.699 646.84)'
					/>
				</clipPath>
			</defs>
			<g clip-path='url(#604xhcotta)' transform='translate(-149.699 -646.84)'>
				<circle
					cx='32'
					cy='32'
					r='32'
					fill='url(#swipe-gradient-bug)'
					transform='translate(149.699 646.84)'
				/>
				<path
					fill='url(#h9budw8vub)'
					d='M46.357 51.715l-5.335 4.758 5.335 4.009-5.335 4.681 24.13 20.8 17.275-9.973 10.081-17.485-24.8-22.3-14.516 2.245-12.17 9.433z'
					opacity='0.25'
					transform='translate(124.872 626.735)'
				/>
				<g>
					<path
						fill='#fff'
						d='M42.133 16.667h-5.994a12.744 12.744 0 0 0-3.872-4.181l3.467-3.467L32.715 6l-4.64 4.64a12.3 12.3 0 0 0-6.016 0L17.419 6 14.4 9.019l3.467 3.467a12.744 12.744 0 0 0-3.872 4.181H8v4.267h4.459a12.8 12.8 0 0 0-.192 2.133V25.2H8v4.267h4.267V31.6a12.8 12.8 0 0 0 .192 2.133H8V38h5.995a12.777 12.777 0 0 0 22.144 0h5.995v-4.267h-4.459a12.8 12.8 0 0 0 .192-2.133v-2.133h4.267V25.2h-4.267v-2.133a12.8 12.8 0 0 0-.192-2.133h4.459zm-12.8 17.067H20.8v-4.267h8.533zm0-8.533H20.8v-4.268h8.533z'
						transform='translate(163.699 658.16) translate(-8 -6)'
					/>
					<path
						fill='url(#61tjovevqc)'
						d='M42.133 16.667h-5.994a12.744 12.744 0 0 0-3.872-4.181l3.467-3.467L32.715 6l-4.64 4.64a12.3 12.3 0 0 0-6.016 0L17.419 6 14.4 9.019l3.467 3.467a12.744 12.744 0 0 0-3.872 4.181H8v4.267h4.459a12.8 12.8 0 0 0-.192 2.133V25.2H8v4.267h4.267V31.6a12.8 12.8 0 0 0 .192 2.133H8V38h5.995a12.777 12.777 0 0 0 22.144 0h5.995v-4.267h-4.459a12.8 12.8 0 0 0 .192-2.133v-2.133h4.267V25.2h-4.267v-2.133a12.8 12.8 0 0 0-.192-2.133h4.459zm-12.8 17.067H20.8v-4.267h8.533zm0-8.533H20.8v-4.268h8.533z'
						transform='translate(163.699 658.16) translate(-6.533 -4.52)'
					/>
				</g>
			</g>
		</svg>
	);
};
